module.exports = __webpack_public_path__ + "static/media/ruby.da0fb340.svg";